import { getCookieConsent } from "../components/CookieBanner";

export function loadMetaPixel(pixelId) {
  if (!pixelId || window.fbq) return;

  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/es_ES/fbevents.js");
  /* eslint-enable */

  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

export function hasMarketingConsent() {
  return !!getCookieConsent()?.marketing;
}

export function readCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}

/** Track a Lead event in the browser Pixel using the shared event id (dedup with CAPI). */
export function trackLead(eventId) {
  if (!hasMarketingConsent() || !window.fbq) return;
  window.fbq("track", "Lead", {}, { eventID: eventId });
}

export function newEventId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `lead-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
